/** @format */

const template = `
<ng-form name="prerequisiteSelectorForm">
  <div class="row">
    <div class="col-12">
      <div class="form-group">
        <form name="courseUnitSearchForm">
          <label ng-if="$ctrl.type === 'CourseUnit'" translate> STUDIES.PREREQUISITES_EDITOR.PREREQUISITE_SELECTOR.COURSE_UNIT </label>
          <label ng-if="$ctrl.type === 'Module'" translate> FIELD_NAMES.studyModule </label>
          <sis-university-select-editor
            [university]="$ctrl.university"
            (university-change)="$ctrl.universityOnChange($event)"
            [place-on-left]="true"
            [compact]="true">
          </sis-university-select-editor>
          <sis-course-unit-search
            ng-if="$ctrl.type === 'CourseUnit'"
            (model-change)="$ctrl.handleSelection($event)"
            [required]="true"
            [search-service]="$ctrl.courseUnitService"
            [university]="$ctrl.university">
          </sis-course-unit-search>
          <sis-module-search
            ng-if="$ctrl.type === 'Module'"
            [include-drafts]="true"
            (model-change)="$ctrl.handleSelection($event)"
            [required]="true"
            [university]="$ctrl.university">
          </sis-module-search>
        </form>
      </div>
    </div>
  </div>
</ng-form>
`;
export default template;
